import { styled } from '@mui/material'

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'focused',
})<{
  focused?: boolean
}>(({ theme, focused }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  alignItems: 'center',
  padding: `${theme.spacing(1)}`,
  minHeight: '32px',
  width: '100%',
  borderRadius: theme.display.borderRadiusSmall,
  backgroundColor: focused ? `${theme.colours.primary}33` : 'white',
  '&:hover': {
    backgroundColor: `${theme.colours.primary}1A`,
    cursor: 'pointer',
    '& :not(span#CaseOverviewCaseType)': {
      color: theme.colours.primary,
    },
  },
  '&.Mui-focused.Mui-focusVisible': {
    backgroundColor: `${theme.colours.primary}33`,
    '& :not(span#CaseOverviewCaseType)': {
      color: theme.colours.primary,
    },
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
}))

export const AddressBox = styled('div')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(12),
  color: theme.colours.baseMid,
  textAlign: 'left',
  padding: `0 ${theme.spacing(0.1)}`,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  display: 'block',
  alignSelf: 'center',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}))
